import * as tslib_1 from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import { Card, Checkbox, Button } from "@/components/UIComponents";
import { ProfileDAO } from "@/API/DAO/ProfileDAO";
import { JsonConvert, OperationMode, ValueCheckingMode } from "json2typescript";
let RegistrationProcessingModalViewModel = class RegistrationProcessingModalViewModel extends Vue {
    constructor() {
        super();
        this.alreadyExists = false;
        this.registrationSuccess = false;
        this.loadingText = "";
        this.showProcessingImage = false;
        this.imageClass = 'marginauto fas fa-sync fa-spin fa-7x';
    }
    async registerUser() {
        this.showProcessingImage = true;
        this.loadingText = "We are preparing your Aileron account";
        let profileResponse;
        try {
            this.profile.verifyEmail = true;
            this.profile.createdBy = 'Self-Registration';
            console.log('Creating profile: ' + JSON.stringify(this.profile));
            profileResponse = await ProfileDAO.createProfile(this.profile);
            this.registrationSuccess = profileResponse.successful;
            if (profileResponse.successful === true) {
                this.showProcessingImage = false;
                this.loadingText = "Your account has been successfully created. You will receive a confirmation email to verify your email address.";
            }
            else {
                this.showProcessingImage = false;
                this.loadingText = profileResponse.message;
            }
        }
        catch (error) {
            this.loadingText = error.response.data.error;
            this.showProcessingImage = false;
            this.imageClass = 'marginauto fas fa-times fa-7x';
        }
    }
    finishedRegistrationAttempt() {
        if (this.registrationSuccess === true) {
            console.log("Registration was successful");
            this.$emit("registrationSuccess");
        }
        else {
            console.log("Error is true, just removing modal");
            this.$emit("registrationFailed");
        }
    }
    async beforeOpen(event) {
        this.showProcessingImage = true;
        this.registrationSuccess = false;
        console.log('Receieved: ' + JSON.stringify(event.params));
        let jsonConvert = new JsonConvert();
        jsonConvert.operationMode = OperationMode.LOGGING;
        jsonConvert.ignorePrimitiveChecks = false;
        jsonConvert.valueCheckingMode = ValueCheckingMode.DISALLOW_NULL;
        this.profile = event.params;
        await this.registerUser();
    }
    mounted() {
        console.log("Mounting modal now...");
    }
};
RegistrationProcessingModalViewModel = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button
        }
    })
], RegistrationProcessingModalViewModel);
export default RegistrationProcessingModalViewModel;
